import xhttp from '@utils/xhttp'
import request from '@utils/request'

/**
 * 创建工作区
 */
export function newWorkspace(params) {
    return xhttp.post('/api/console-proxy/workspace/workspaces', params)
}

/**
 * 删除工作区列表
 */
export function deleteWorkspace(params) {
    const { workspaceId } = params

    delete params.workspaceId
    return xhttp.delete(`/api/console-proxy/workspace/workspaces/${workspaceId}`, { params })
}

/**
 * 编辑工作区列表
 */
export function editWorkspace(params) {
    const { workspaceId, appId } = params
    return xhttp.put(`/api_v3/studio/app/${appId}/branch/${workspaceId}`, params)
}

/**
 * 获取工作区列表
 */
export function getWorkspaceList(params) {
    return xhttp.get('/api/console-proxy/workspace/workspaces', { params })
}

/**
 * 获取应用版本列表
 */
export function getAppVersionList(params) {
    return xhttp.get('/api/console-proxy/app-list', { params })
}

/**
 * 获取工作区可引用组件列表
 */
export function getWorkspaceComponentsList() {
    return xhttp.get('/api_v3/studio/workspace-component/can-refer')
}

/**
 * 添加工作区引用组件
 */
export function addComponentQuotes(params) {
    return xhttp.post('/api_v3/studio/workspace-component', params)
}

/**
 * 删除工作区引用组件
 */
export function deleteComponentQuotes(params) {
    return xhttp.delete('/api_v3/studio/workspace-component', { params })
}

/**
 * 更新工作区引用组件
 */
export function updateComponentQuotesVerison(params) {
    return xhttp.put('/api_v3/studio/workspace-component', params)
}

/**
 * 获取工作区已引用组件列表
 */
export function getWorkspaceQuotesComponentsList() {
    return xhttp.get('/api_v3/studio/workspace-component/has-refer')
}

/**
 * 获取单个应用信息
 */
export function getAppVersion(params) {
    const { appId } = params
    return xhttp.get(`/api/console-proxy/app/${appId}`)
}

/**
 * 获取全部引擎
 */
export function getEngineVersion() {
    return xhttp.get('/api/console-proxy/engine-version-list')
}

/**
 * 获取全部业务环境列表
 */
export function getEnvList(params) {
    return xhttp.get('/api_v3/studio/business-env/category-list', { params })
}

/**
 * 获取应用版本列表
 */
export function getVersionEnvList(params) {
    return xhttp.get('/api/console-proxy/app-version-list', { params })
}

/**
 * 删除应用版本
 */
export function deleteAppVersion(params) {
    return xhttp.delete(`/api/console-proxy/app-version/${params.id}`, { params })
}

/**
 * 获取应用版本详情
 */
export function getAppVersionDetail(params) {
    return xhttp.get(`/api/console-proxy/app-version/${params.id}`, { params })
}

/**
 * 获取应用版本引用的组件
 */
export function getAPPVersionComponents(params) {
    return xhttp.get(`/api/console-proxy/app-version/components-list/${params.id}`, { params })
}

/**
 * 换取appcloud ticket 需要的token
*/
export function getAPPCloudToken(params) {
    return xhttp.post('/api/console-proxy/app-cloud/login', params)
}

/**
 * 获取角色列表
 * @returns {Promise}
 */
export function getRolesList(params) {
    return request.get('/api/role-auth/role', {
        params,
    })
}

/**
 * 添加角色
 * @returns {Promise}
 */
export function addRole(params) {
    return request.post('/api/role-auth/role', params)
}

/**
 * 删除角色
 * @returns {Promise}
 */
export function deleteRole(id) {
    return request.delete(`/api/role-auth/role/${id}`)
}

/**
 * 修改角色
 * @returns {Promise}
 */
export function updateRole(id, params) {
    return request.put(`/api/role-auth/role/${id}`, params)
}

/**
 *  获取应用所有tag
 * @param {*} params
 */
export function getBranchTags(params) {
    const { appId } = params
    return request.get(`/api/info/app/${appId}/tags`)
}

/**
 *  选中分支
 * @param {*} id appId
 * @param {*} params
 */
export function selectDefaultBranch(params) {
    return request.post('/api/info/app/user-select-workspace', params)
}

export function getBranchSelected(appId, workspaceId) {
    return request.get(`/api_v3/studio/app/${appId}/workspace-info/${workspaceId}`)
}
